import { InspireCardVariant } from './types';

export const COPIES_PREFIX = 'inspire_listings.inspire_card';
export const DEFAULT_IS_TOUCH = false;
export const DEFAULT_VARIANT = InspireCardVariant.grid;
